export default {
  data() {
    return {
      paysafe: null,
      paramPaysafe: null,
      loading: false,
      paramsModale: {
        // Montant de la transaction
        montant: null,
        // Nom du payeur
        holderName: null,
        // Langue d'affichage de la modale paysafe
        langue: 'fr_CA',
        // Devise de paiement
        devise: 'CAD',
        // Nom de l'entreprise à afficher dans la modale
        companyName: 'Université de Sherbrooke',
        // Label du bouton de paiement
        buttonLabel: "Confirmer",
        displayPaymentMethods: ["Cards", "DirectDebit"],
        preferredPaymentMethod: "Cards",
        billingAddress: {
          country: "CA"
        }
      },
    }
  },

  methods: {
    async showPaysafeModale(montant, holderName = "") {

      // Validation des paramètres obligatoires
      if (montant <= 0) {
        console.error("ErreurPaysafeMixin: Le montant doit être supérieur à 0.")
        return;
      }

      this.paramsModale.montant = montant
      this.paramsModale.holderName = holderName

      this.loading = true
      // Chargement du script de la librairie Paysafe checkout
      if (!this.paysafe) {
        if (!window.paysafe) {
          await this.$loadScript(process.env.VUE_APP_PAYSAFE_SDK)
        }
        this.paysafe = window.paysafe
      }

      // Chargement des clé d'api et environement
      this.chargerParamPaysafe().then(response => {
        this.paramPaysafe = response.data
        // Affichage de la modale
        this.showPaysafe(montant, holderName)
      })
    },

    chargerParamPaysafe() {
      return this.$axios.api.get('paysafeparams')
    },

    // Affiche la modale
    showPaysafe() {
      this.paysafe.checkout.setup(
        this.paramPaysafe.singleUseToken,
        this.getOptionsPaysafe(),
        this.onSubmitPaysafe,
        this.onClosePaysafe
      )
    },

    // Genere l'objet de paramètrage pour affichage de la modale Paysafe
    getOptionsPaysafe() {
      var baseOptions = {
        amount: parseInt(this.paramsModale.montant * 100),
        holderName: this.paramsModale.holderName,
        currency: this.paramsModale.devise,
        companyName: this.paramsModale.companyName,
        locale: this.paramsModale.langue,
        buttonLabel: this.paramsModale.buttonLabel,
        environment: this.paramPaysafe.environment,
        imageUrl: process.env.VUE_APP_LOGO_PAYSAFE,
        displayPaymentMethods: this.paramsModale.displayPaymentMethods,
        preferredPaymentMethod: this.paramsModale.preferredPaymentMethod,
        billingAddress: this.paramsModale.billingAddress
      }
      return baseOptions
    },
    // Evenement déclenché lorsque paysafe nous renvoit une réponse après avoir entré les informations de CB dans la modale
    onSubmitPaysafe(instance, error, result) {
      if (instance) {
        instance.close()
      }
      if (error) {
        console.error(error)
        
        if (this.onFailurePaysafe) {
          this.onFailurePaysafe(error.code, error.displayMessage, error.detailedMessage)
        }
        
        return
      }
      if (this.onSuccessPaysafe) {
        this.onSuccessPaysafe(result.token, result.paymentMethod)
      }
    },
    onClosePaysafe(stage) {
      this.loading = false
      if (stage === 'BeforePayment') {
        if (this.onCloseBeforePayment) {
          this.onCloseBeforePayment()
        }
        // No payment have been made
      } else if (stage === 'DuringPayment') {
        // Token have been issued, but the checkout overlay was closed from the user before instance flow control method was invoked
      } else if (stage === 'AfterPayment') {
        // Closed either via instance.close method or by the user from the success screen
      }
    },
  }
}
